import { toast } from 'vue3-toastify'

/** 全局轻提示，供业务代码与 HTTP 拦截器统一调用 */
export function showToast(message: string, duration = 2000): void {
  if (!message.trim()) {
    return
  }

  toast(message, { autoClose: duration })
}
